import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { useSession } from "../../../hooks";
import { useGetTeam } from "../../../http";
import { Plan, TeamStrategyFilterButton } from "../../TeamPages/TeamStrategicMapPage/components";
import { useTeamMeetingSettings } from "../hooks";

interface IProps {
  teamName: string;
  teamSlug: string;
}

const TeamStrategicMapReview = (props: IProps) => {
  const { userId } = useSession();
  const { data: team, isLoading: isLoadingTeam } = useGetTeam(props.teamSlug, userId);
  const { settings, updateStrategySettings } = useTeamMeetingSettings(props.teamSlug);

  const hasEditPermission = (team?.isAdministrator || team?.isMember) ?? false;

  if (!isLoadingTeam && team && team.planGuid != null) {
    return (
      <Plan
        teamName={props.teamName}
        teamSlug={props.teamSlug}
        planGuid={team.planGuid}
        canEdit={hasEditPermission}
        meetingView
        tableView={settings.strategy.tableView}
        onViewToggled={(tableView) =>
          updateStrategySettings({
            tableView,
          })
        }
        filters={settings.strategy.filters}
        headerContent={({ isLoading, plan }) => {
          return isLoading || !plan ? (
            <Stack spacing={0.25} width={"100%"}>
              <Skeleton variant="rectangular" height={25} width={"25%"} />
              <Skeleton variant="rectangular" height={25} width={"100%"} />
            </Stack>
          ) : (
            <Stack spacing={0.25}>
              <Typography variant="h5">Strategic Map</Typography>
              <Typography
                variant="body1"
                title={`Last changed by ${plan.lastModifiedByDisplayName} on ${DateTime.fromISO(plan.lastModifiedUtc, {
                  zone: "utc",
                })
                  .toLocal()
                  .toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS)}`}
              >
                {`Last changed by ${plan.lastModifiedByDisplayName} on ${DateTime.fromISO(plan.lastModifiedUtc, {
                  zone: "utc",
                })
                  .toLocal()
                  .toLocaleString(DateTime.DATE_FULL)}`}
              </Typography>

              <Box sx={{ pt: 0.5 }}>
                <TeamStrategyFilterButton
                  planGuid={plan.guid}
                  filters={settings.strategy.filters}
                  onFiltersChanged={(filters) => updateStrategySettings({ filters })}
                />
              </Box>
            </Stack>
          );
        }}
      />
    );
  }

  return null;
};

export { TeamStrategicMapReview };
